import ResourceManager from "@/components/common/ResourceManager";
import { eur, fdate } from "@/lib/format";
import { DeadlineBadge } from "@/components/common/Badges";

const vehLabel = (id, lookups) => {
  const v = (lookups.vehicles || []).find((x) => x.id === id);
  return v ? `${v.brand} ${v.model} (${v.registration})` : "—";
};
const statusFromDate = (d) => {
  if (!d) return "neutral";
  const days = Math.ceil((new Date(d) - new Date()) / 86400000);
  if (days < 15) return "critical"; if (days <= 30) return "warning"; return "ok";
};
const urlFilters = {
  echeance: {
    label: (v) => `Échéance < ${v} jours`,
    test: (r, v) => r.end_date && Math.ceil((new Date(r.end_date) - new Date()) / 86400000) < Number(v),
  },
};

export default function Insurances() {
  const columns = [
    { key: "vehicle_id", label: "Véhicule", render: (r, l) => vehLabel(r.vehicle_id, l) },
    { key: "insurer", label: "Assureur" },
    { key: "contract_number", label: "N° contrat", render: (r) => <span className="font-mono text-xs">{r.contract_number}</span> },
    { key: "premium", label: "Prime", render: (r) => eur(r.premium) },
    { key: "franchise", label: "Franchise", render: (r) => eur(r.franchise) },
    { key: "end_date", label: "Échéance", render: (r) => <DeadlineBadge level={statusFromDate(r.end_date)}>{fdate(r.end_date)}</DeadlineBadge> },
  ];
  const fields = [
    { key: "vehicle_id", label: "Véhicule", type: "vehicle", full: true },
    { key: "insurer", label: "Assureur" },
    { key: "contract_number", label: "N° de contrat" },
    { key: "start_date", label: "Date début", type: "date" },
    { key: "end_date", label: "Date fin", type: "date" },
    { key: "premium", label: "Prime annuelle (€)", type: "number" },
    { key: "franchise", label: "Franchise (€)", type: "number" },
  ];
  return <ResourceManager title="Assurances" subtitle="Contrats d'assurance de la flotte." resource="insurances" exportCollection="insurances" columns={columns} fields={fields} lookupsNeeded={["vehicles"]} attach={{ refType: "insurance", category: "Assurance", matchVehicle: true }} urlFilters={urlFilters} />;
}
